import { observer } from 'mobx-react-lite'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import RootStore from '../../store/RootStore'
import AuthorizationInputs from '../../components/forms/AuthorizationInputs'

type Props = {}

const Registration = observer((props: Props) => {
  const navigate = useNavigate()

  const { username, password } = RootStore.authUi

  const [surname, setSurname] = React.useState('')
  const [last_name, setLastName] = React.useState('')
  const [first_name, setFirstName] = React.useState('')

  const [error, setError] = React.useState<any>()
  const [success, setSuccess] = React.useState(false)

  const hundleRegistrate = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault()
    try {
      await RootStore.authStore.register({
        username,
        password,
        surname,
        last_name,
        first_name,
      })
      setError(null)
      setSuccess(true)
      setTimeout(() => {
        navigate('/')
      }, 1500)
    } catch (error: any) {
      const data = error.response?.data
      if (data.property) {
        setError(data.property)
      } else {
        setError({ password: error.message })
      }
    }
  }

  return (
    <form className="Authorization-card-form">
      <AuthorizationInputs
        title="Имя пользователя*"
        type="text"
        error={error?.username ?? null}
        defaultValue={username}
        onChange={(event) => {
          RootStore.authUi.setUsername(event.target.value)
        }}
      />

      <AuthorizationInputs
        title="Пароль*"
        type="password"
        error={error?.password ?? null}
        defaultValue={password}
        onChange={(event) => {
          RootStore.authUi.setPassword(event.target.value)
        }}
      />
      <AuthorizationInputs
        title="Фамилия"
        type="text"
        error={error?.surname ?? null}
        onChange={(event) => {
          setSurname(event.target.value)
        }}
      />
      <AuthorizationInputs
        title="Имя"
        type="text"
        error={error?.first_name ?? null}
        onChange={(event) => {
          setFirstName(event.target.value)
        }}
      />
      <AuthorizationInputs
        title="Отчество"
        type="text"
        error={error?.last_name ?? null}
        onChange={(event) => {
          setLastName(event.target.value)
        }}
      />
      <button
        className={`Authorization-card-form-inputs-button ${
          success ? 'success' : ''
        }`}
        onClick={hundleRegistrate}
        disabled={success}
      >
        {success ? 'Успешно' : 'Зарегестрироваться'}
      </button>
    </form>
  )
})

export default Registration
